module.exports = __webpack_public_path__ + "img/iglo.3cf323dd.png";